var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.onProviderRoute),expression:"onProviderRoute"}]},[_c('Grid',{attrs:{"providers":_vm.localProviders,"games":_vm.games}})],1),_c('router-view',{attrs:{"providers":_vm.localProviders,"games":_vm.games}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }